/**
 * The Westminster Room seats up to 100 guests but the First toast service is
 * capped at 30, so its services carry an extra guest-capacity notice in the
 * First toast sections of the add-ons and extend journeys. Other rooms are
 * within the 30-guest limit and show no notice.
 */
export const FIRST_TOAST_GUEST_NOTICE_SERVICE_IDS: ReadonlySet<number> = new Set([
  48375, // Marriage — The Westminster Room
  48403, // Civil Partnership — The Westminster Room
  48457, // Civil Partnership Conversion — The Westminster Room
  48471, // Naming — The Westminster Room
  48483, // Commitment — The Westminster Room
  48497, // Renewal of Vows — The Westminster Room
]);

export const FIRST_TOAST_GUEST_NOTICE =
  'First toasts are only available to ceremonies attended by fewer than 30 guests. '
  + 'You have booked the Westminster Room which has capacity for up to 100 guests. '
  + 'If you have more than 30 guests we cannot, unfortunately, offer a first toast service. '
  + 'If you are inviting 30 guests or fewer please continue with your order.';

/**
 * Shown on the add-ons confirmation page when the purchase included a First
 * toast, so the customer is told when it will be served (Westminster UAT, card
 * pbjvPrIg).
 */
export const FIRST_TOAST_SERVED_NOTICE =
  'Your First toast will be served at the end of the ceremony.';

export function requiresFirstToastGuestNotice(globalServiceId: unknown): boolean {
  const id = Number(globalServiceId);
  return Number.isFinite(id) && FIRST_TOAST_GUEST_NOTICE_SERVICE_IDS.has(id);
}
